/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { ScrollRevealImageComponentDisplay } from "cms/components/components/scroll-reveal/display";
import { ScrollRevealImageComponentEditor } from "cms/components/components/scroll-reveal/edit";
import { getComponentZoneLayout } from "cms/components/components/component";

const ScrollRevealImageComponent = (props) => {
    
    const { ...everything } = props;
    const zoneProps = {
        ...everything,
        displayComponent: <ScrollRevealImageComponentDisplay />,
        editComponent: <ScrollRevealImageComponentEditor />,
    };
    return getComponentZoneLayout(zoneProps);
};

ScrollRevealImageComponent.displayName = "ScrollRevealImageComponent";
export { ScrollRevealImageComponent };
